import { h } from 'vue'
import AtomButton from '~/components/atoms/button/button.vue'
import OrganismHubspotNativeForm from '~/components/organisms/hubspot-native-form/hubspot-native-form.vue'
import UiComponentContainer from '~ui/components/container/container.vue'
import UiComponentHeading from '~ui/components/heading/heading.vue'
import UiComponentParagraph from '~ui/components/paragraph/paragraph.vue'
import UiComponentWrapper from '~ui/components/wrapper/wrapper.vue'

const Functional = (props) => {
  return h(UiComponentWrapper, { class: 'form' }, () => [
    h(UiComponentContainer, {}, () => [
      h(UiComponentWrapper, { class: 'content' }, () => [
        h(
          UiComponentHeading,
          {
            level: 4,
          },
          () => [props.record.title || props.currentForm.firstStepTitle],
        ),
        h(
          UiComponentParagraph,
          {},
          () => [props.record.text || props.currentForm.firstStepText],
        ),
      ]),
      h(UiComponentWrapper, { class: 'action' }, () => [
        !!props.page.formType
        && !props.forms[props.currentForm.slug].hasBeenSubmitted
        && h(OrganismHubspotNativeForm, {
          formId: props.currentForm.formId,
          uniqueId: `landing-${props.currentForm.slug}-form-${props.record.id}`,
          ['onHubspot:form:submitted']: submittedValues => props.onSubmitted(props.currentForm, submittedValues),
        }),

        !!props.page.formType
        && props.forms[props.currentForm.slug].hasBeenSubmitted
        && h(UiComponentWrapper, { class: 'success' }, () => [
          h(UiComponentParagraph, {}, () => [
            h('div', {
              innerHTML: props.markdown.render(
                props.currentForm.lastStepText || '',
              ),
            }),
          ]),
          !!props.currentForm.lastStepCta && h(
            AtomButton,
            {

              to: props.currentForm.lastStepCta.slug,
              size: 'l',
            },
            () => [props.currentForm.lastStepCta.slot],
          ),
        ]),

        props.page.formType === null
        && h(
          'iframe',
          {
            height: props.signupForm.height,
            loading: 'lazy',
            src: props.signupForm.url,
            title: 'Livestorm Sign up',
            width: '100%',
          },
          [],
        ),
      ]),
    ]),
  ])
}

Functional.props = {
  currentForm: {
    required: false,
    type: Object,
  },
  forms: {
    required: true,
    type: Object,
  },
  isLogged: {
    required: true,
    type: Boolean,
  },
  markdown: {
    required: true,
    type: Object,
  },
  onSubmitted: {
    required: true,
    type: Function,
  },
  page: {
    required: true,
    type: Object,
  },
  primaryButton: {
    required: true,
    type: Object,
  },
  record: {
    required: true,
    type: Object,
  },
  signupForm: {
    required: true,
    type: Object,
  },
}

export default Functional
